const RouteEndPoints = {
    HOME_PAGE: '/',
    WELCOME_PAGE: "/welcome",
    AI_LABS_PAGE: '/ai-labs',
    AI_LAB_DETAIL_PAGE: '/ai-labs',   // + '/:slug'
    AI_LAB_SOLVE_PAGE: '/ai-labs',    // + '/:slug/solve?attempt=<id>'
    AI_LAB_PORTFOLIO_PAGE: '/ai-labs/portfolio',
    AI_LAB_CERTIFICATE_PAGE: '/ai-lab-certificate',   // + '/:publicId'
    AI_LAB_SOLUTION_PAGE: '/ai-lab-solution',        // + '/:attemptId' (read-only)
    // Public marketing page on www (like MICRO_DEGREE_PAGE) — "Know More" for a lab the learner
    // hasn't purchased opens here (+ '<slug>'), not the internal classroom detail route.
    AI_LABS_MARKETING_PAGE: 'https://www.edyoda.com/ai-labs/',
    PROGRAM_MODULES_PAGE: '/program-modules',
    PROGRAM_INSTRUCTORS_PAGE: '/program-instructors',
    PROGRAM_SUBMISSIONS_PAGE: '/program-submissions',
    PROGRAM_PERFORMANCE_PAGE: '/program-performance',
    PROGRAM_CERTIFICATIONS_PAGE: '/program-certifications',
    BATCHMATES_PAGE: '/batchmates',
    MY_PROFILE: '/profile',
    PUBLIC_PROFILE: '/profile/public',
    SETTINGS_PAGE: '/settings',
    ALL_NOTIFICATIONS: '/notifications/all',
    CREATE_NOTIFICATIONS: '/notifications/create',
    FAQ_PAGE: '/faqs',
    FAQ: 'https://www.edyoda.com/faq',
    QUIZ_PAGE: '/start-quiz',
    PUBLIC_PROFILE: '/profile/public',
    EDIT_PROFILE: '/profile/edit',
    CHANGE_PASSWORD_PAGE: '/change-password',
    RESET_PASSWORD: '/user/password-reset/confirm',
    LOGIN_PAGE: '/login',
    LIVE_SESSION_PAGE: '/join-live-session',
    FEEDBACK_PAGE: '/submit-feedback',
    ALL_MODULES_PAGE: '/instructor/modules-all',
    CURRICULUM_PAGE: '/instructor/module-curriculum',
    PLANNER_PAGE: '/instructor/curriculum-planner',
    EVALUATION_PAGE: '/instructor/evaluation',
    REPORTS_PAGE: '/instructor/reports',

    PROGRAM_ANALYTICS_PAGE: '/program-analytics',
    PROGRAMS_PAGE: '/manage-programs',
    TEMPLATES_PAGE: '/manage-templates',
    MANAGE_REPORTS_PAGE: '/manage-reports',
    USERS_PAGE: '/manage-users',
    CONTACT_US_PAGE: '/contact-us',
    CUSTOMER_SUPPORT_PAGE: '/customer-support',
    UPDATE_JOB_PROFILE: '/update-job-profile',
    INSTRUCTOR_PUBLIC_PROFILE: '/instructor-public-profile',
    CERTIFICATION_PAGE: '/certification',
    CERTIFICATION_THANK_YOU_PAGE: '/certification/apply/success',
    CERTIFICATION_PENDING_APPLICATION_PAGE: '/certification/apply/pending',
    REFERRAL_PAGE: '/referral',
    REDEEM_REWARDS_PAGE: '/redeem',

    PLACEMENTS: "/placements",
    SUPPORT_CHAT: "/support-chat",

    DISCOURSE_LOGIN: "/discourse-sso",

    FEATURE_REQUESTS_PAGE: '/feature-requests',
    NOT_FOUND: '/not-found',
    SERVER_ERROR: '/something-went-wrong',
    UNAUTHORIZED_ERROR: '/unauthorized',
    PROFILE_CERTIFICATE: '/public-profile',
    UPDATE_CERTIFICATION_DETAILS_PAGE: '/update-certification-details',
    CAREER_TRACK_PROGRAMS: '/career-track-programs',
    PUBLIC_MD_CERTIFICATE_PAGE: '/public-certificate',
    CATEGORIES_PAGE: '/categories',
    CATALOGUE_PAGE: '/catalogue',
    B2B_COURSE_DETAILS_PAGE: '/course-details',
    JOB_PROGRAMS_PAGE: '/job-programs',
    JOB_PROGRAM_PAGE: 'https://www.edyoda.com/job-program/',
    RAAS_PAGE: 'https://www.edyoda.com/raas/',
    MICRO_DEGREE_PAGE: 'https://www.edyoda.com/micro-degree/',
    MOCK_EXAM_PAGE: 'https://www.edyoda.com/mock-exam/',

    DIGITAL_MARKETING_MICRO_DEGREE: 'digital-marketing-micro-degree',
    REACT_JS_NEW_MICRO_DEGREE: 'react-js-micro-degree',
    WEB_DEVELOPMENT_MICRO_DEGREE: 'web-development-micro-degree',
    FRONTEND_DEVELOPMENT_MICRO_DEGREE: 'frontend-development-micro-degree',
    PYTHON_DEVELOPER_MICRO_DEGREE: 'python-for-ai-ml-micro-degree',
    PYTHON_DEVELOPMENT_MICRO_DEGREE: 'python-development-micro-degree',
    AI_ML_MICRO_DEGREE_NEW: 'ai-ml-micro-degree',
    JAVA_DEVELOPER_MICRO_DEGREE: 'java-development-micro-degree',
    JAVA_DEVELOPER_ADVANCED_MICRO_DEGREE: 'advanced-java-development-micro-degree',
    DATA_ANALYSIS_MICRO_DEGREE: 'data-analysis-micro-degree',
    AWS_MICRO_DEGREE: 'aws-solutions-architect-micro-degree',
    AWS_SAA_C03_MICRO_DEGREE: 'aws-solutions-architect-SAA-C03-micro-degree',
    BA_MICRO_DEGREE: 'business-analysis-micro-degree',
    POWER_BI_MICRO_DEGREE: 'power-bi-micro-degree',

    DEVOPS_MICRO_DEGREE: 'devops-engineer-micro-degree',
    DOCKER_MICRO_DEGREE: 'docker-certified-associate-micro-degree',
    KUBERNETES_MICRO_DEGREE: 'certified-kubernetes-administrator-micro-degree',
    TABLEAU_MICRO_DEGREE: 'tableau-certification-micro-degree',

    AWS_ASSOCIATE_MICRO_DEGREE: 'aws-certified-solutions-architect-associate-micro-degree',
    AWS_PROFESSIONAL_MICRO_DEGREE: 'aws-certified-solutions-architect-professional-micro-degree',
    AWS_CLOUD_PRACTITIONER_MICRO_DEGREE: 'aws-cloud-practitioner-micro-degree',
    AZURE_SOLUTIONS_ARCHITECT_MICRO_DEGREE: 'azure-solutions-architect-micro-degree',
    PMP_MICRO_DEGREE: 'project-management-professional-micro-degree',
    ITIL_FOUNDATION_MICRO_DEGREE: 'itil-4-foundation-micro-degree',
    AZURE_DEVOPS_MICRO_DEGREE: 'azure-devops-engineer-micro-degree',
    GCP_CLOUD_ARCHITECT_MICRO_DEGREE: 'google-cloud-architect-micro-degree',
    CEH_V12_MICRO_DEGREE: 'ethical-hacking-certification-micro-degree',
    CYBER_SECURITY_MICRO_DEGREE: 'cybersecurity-micro-degree',
    MULTI_CLOUD_MICRO_DEGREE: 'multi-cloud-architect-micro-degree',
    EXCEL_MICRO_DEGREE: 'microsoft-excel-expert-micro-degree',

    DATA_ANALYSIS_USING_PYTHON: 'data-analysis-using-python-micro-degree',
    MACHINE_LEARNING_USING_PYTHON: 'machine-learning-using-python-micro-degree',
    DATA_SCIENCE_USING_PYTHON: 'data-science-using-python-micro-degree',
    GENERATIVE_AI_USING_PYTHON: 'generative-ai-using-python-micro-degree',
    AI_FULLSTACK_DEVELOPMENT: 'ai-fullstack-development-micro-degree',
    BACKEND_DEVELOPMENT_USING_NODEJS: 'backend-development-using-nodejs-micro-degree',
    MERN_FULLSTACK_DEVELOPMENT: 'mern-fullstack-development-micro-degree',
    FA_MICRO_DEGREE: 'finance-analysis-micro-degree',

    AZURE_ADMINISTRATOR_ASSOCIATE_104: 'microsoft-azure-administrator-associate-micro-degree',
    AZURE_SOLUTIONS_ARCHITECT_305: 'microsoft-azure-solutions-architect-az305-micro-degree',

    AWS_MOCK_EXAM: 'https://www.edyoda.com/mock-exam/aws-solutions-architect-associate',
    AZURE_MOCK_EXAM: 'https://www.edyoda.com/mock-exam/azure-solutions-architect',
    PMP_MOCK_EXAM: 'https://www.edyoda.com/mock-exam/project-management-professional',
    CEH_V12_MOCK_EXAM: 'https://www.edyoda.com/mock-exam/ethical-hacking-certification',

    CYBER_SECURITY_CAREER_TRACK_MICRO_DEGREE: 'cybersecurity-career-track-micro-degree',
    DSAI_CAREER_TRACK_MICRO_DEGREE: 'data-science-with-genai-career-track-micro-degree',
    MANAGEMENT_CAREER_TRACK_MICRO_DEGREE: 'management-career-track-micro-degree',
    MULTI_CLOUD_DEVOPS_CAREER_TRACK_MICRO_DEGREE: 'multi-cloud-devops-career-track-micro-degree',
}

Object.freeze(RouteEndPoints);

export default RouteEndPoints;